import { render } from "./UnconfirmedProducerOrders.vue?vue&type=template&id=067c2a4c"
import script from "./UnconfirmedProducerOrders.vue?vue&type=script&lang=js"
export * from "./UnconfirmedProducerOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__